import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { TokenService } from './auth-token.service';
import { EventService } from '../event.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

    constructor(
        protected router: Router,
        protected token: TokenService,
        protected message: EventService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        // console.log(route.routeConfig)
        // return true;
        return this.hasValidUser() && this.hasAnyRole(route.data['roles']);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        // console.log(childRoute.routeConfig)
        // return true;
        return this.hasAnyRole(childRoute.data['roles']);
    }

    hasValidUser() {
        return this.hasUser() && this.isNotExpired();
    }

    hasUser() {
        return this.token.whoAmI() != null;
    }

    isNotExpired() {
        return !this.token.whoAmI().isTokenExpired();
    }

    hasAnyRole(roles: string[]) {
        return roles != null
            ? this.checkRoles(roles)
            : true;
    }
    checkRoles(roles: string[]) {
        if (this.token.whoAmI().hasAnyRole(roles)) {
            return true;
        } else {
            return false; // this.message.error("invalid Access. Required roles not granted!", );
        }
    }
}
